import React, { useEffect, useState } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

const ClientSessions = () => {
  const [sessions, setSessions] = useState([]);

  useEffect(() => {
    axios.get(`${API}/api/portal/sessions`, { withCredentials: true }).then(r => setSessions(r.data)).catch(() => {});
  }, []);

  return (
    <div data-testid="client-sessions">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '2rem' }}>
        <div>
          <h1 className="portal-page-title">My Sessions</h1>
          <p className="portal-page-subtitle" style={{ margin: 0 }}>View your session history and upcoming sessions</p>
        </div>
        <a href="https://calendly.com" target="_blank" rel="noopener noreferrer" className="portal-btn portal-btn-primary" data-testid="book-session-btn">Book a Session</a>
      </div>

      {sessions.length === 0 ? (
        <div className="portal-empty">
          <p>No sessions yet. Book your first advisory session to get started.</p>
        </div>
      ) : (
        sessions.map(s => (
          <div key={s.id} className="portal-card">
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
              <div>
                <span className="portal-badge">{s.duration}</span>
                <h3 style={{ marginTop: '0.5rem' }}>Session: {s.session_date}</h3>
              </div>
            </div>
            {s.summary && (
              <div style={{ marginTop: '0.75rem' }}>
                <strong style={{ fontSize: '0.82rem', color: '#5A6C8A', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Summary</strong>
                <p>{s.summary}</p>
              </div>
            )}
            {s.action_items && (
              <div style={{ marginTop: '0.75rem' }}>
                <strong style={{ fontSize: '0.82rem', color: '#5A6C8A', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Action Items</strong>
                <p>{s.action_items}</p>
              </div>
            )}
            {s.recommendations && (
              <div style={{ marginTop: '0.75rem' }}>
                <strong style={{ fontSize: '0.82rem', color: '#5A6C8A', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Recommendations</strong>
                <p>{s.recommendations}</p>
              </div>
            )}
          </div>
        ))
      )}
    </div>
  );
};

export default ClientSessions;
